import { cfb2026Outcomes } from "./LandingDemoData"
import { LandingDemoNFLBracket as BaseBracket } from "./LandingDemoNFLBracket"

type Props = Parameters<typeof BaseBracket>[0]

export function LandingDemoCFBBracket(
  props: Omit<
    Props,
    "title" | "outcomes" | "imageUrl" | "volume" | "progress" | "ends" | "dateStart" | "dateEnd" | "state" | "simulate"
  >,
) {
  return (
    <BaseBracket
      title="2026 CFB Playoff"
      outcomes={cfb2026Outcomes}
      imageUrl="https://a.bracky.app/assets/covers/cfb/cfb-playoff-2026.jpg"
      volume={350000}
      progress={5}
      ends={new Date("2027-01-15")}
      dateStart={new Date("2026-08-24")}
      dateEnd={new Date("2027-01-15")}
      state="live"
      simulate
      {...props}
    />
  )
}
